<div class="ingredient-sides mb-3 px-3" role="region" aria-label="Pizza side selection">
  <span class="ingredient-sides-selected">
    Choose a Side:
    <span class="selected sr-only">
      <span aria-live="polite">
        Currently selected: {{ selectedOption ? selectedOption.name : 'None' }}
      </span>
    </span>
  </span>
  <span class="ingredient-sides-shell" role="radiogroup" aria-label="Pizza side options">
    <ng-container *ngIf="!optionSubGroup; else subOptionGroupChoices">
      <ng-container *ngTemplateOutlet="optionGroupChoices"></ng-container>
    </ng-container>
  </span>
</div>

<ng-template #optionGroupChoices>
  <button type="button" class="side"
          [attr.aria-pressed]="optionGroup.options[0].optionID === selectedOption?.optionID"
          [attr.aria-label]="'Left half only'"
          (click)="$event.stopPropagation(); optionClicked(optionGroup.options[0])">
    <div class="side-left" [class.active]="optionGroup.options[0].optionID === selectedOption?.optionID"></div>
  </button>
  <button type="button" class="side"
          [attr.aria-pressed]="optionGroup.options[1].optionID === selectedOption?.optionID"
          [attr.aria-label]="'Whole pizza'"
          (click)="$event.stopPropagation(); optionClicked(optionGroup.options[1])">
    <div class="side-whole" [class.active]="optionGroup.options[1].optionID === selectedOption?.optionID"></div>
  </button>
  <button type="button" class="side"
          [attr.aria-pressed]="optionGroup.options[2].optionID === selectedOption?.optionID"
          [attr.aria-label]="'Right half only'"
          (click)="$event.stopPropagation(); optionClicked(optionGroup.options[2])">
    <div class="side-right" [class.active]="optionGroup.options[2].optionID === selectedOption?.optionID"></div>
  </button>
</ng-template>
<ng-template #subOptionGroupChoices>
  <ng-container *ngFor="let childOption of optionSubGroup.subOptions">
    <ng-container *ngIf="childOption.name === 'Left Half'">
      <button type="button" class="side side-left"
              [attr.aria-pressed]="childOption.option.optionID === selectedSubOption?.optionID"
              [attr.aria-label]="'Left half only'"
              (click)="$event.stopPropagation(); subOptionClicked(childOption.option)"
              [class.active]="childOption.option.optionID === selectedSubOption?.optionID">
      </button>
    </ng-container>
  </ng-container>

  <ng-container *ngFor="let childOption of optionSubGroup.subOptions">
    <ng-container *ngIf="childOption.name === 'Whole Pie'">
      <button type="button" class="side side-whole"
              [attr.aria-pressed]="childOption.option.optionID === selectedSubOption?.optionID"
              [attr.aria-label]="'Whole pizza'"
              (click)="$event.stopPropagation(); subOptionClicked(childOption.option)"
              [class.active]="childOption.option.optionID === selectedSubOption?.optionID">
      </button>
    </ng-container>
  </ng-container>

  <ng-container *ngFor="let childOption of optionSubGroup.subOptions">
    <ng-container *ngIf="childOption.name === 'Right Half'">
      <button type="button" class="side"
              [attr.aria-pressed]="childOption.option.optionID === selectedSubOption?.optionID"
              [attr.aria-label]="'Right half only'"
              (click)="$event.stopPropagation(); subOptionClicked(childOption.option)"
              [class.active]="childOption.option.optionID === selectedSubOption?.optionID">
        <div class="side side-right"></div>
      </button>
    </ng-container>
  </ng-container>
</ng-template>